import { render, staticRenderFns } from "./CaTable.vue?vue&type=template&id=c3a2d11e"
import script from "./CaTable.vue?vue&type=script&lang=ts"
export * from "./CaTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports